/**
 * Shared trading-control state model (proposal 10 — trading control states).
 *
 * One union describes every visual state a trading control can be in, plus a
 * helper that derives the ARIA attributes assistive tech needs to read that
 * state. Presentational only — no persistence, no network.
 */
export type ControlState = "idle" | "hover" | "inFlight" | "disabled";

/** ARIA attributes derived from a {@link ControlState}. */
export interface ControlAriaAttrs {
  "aria-busy"?: boolean;
  "aria-disabled"?: boolean;
}

/**
 * Map a control state to the ARIA attributes that expose it to assistive tech.
 * - `inFlight` → `aria-busy` (an order is being submitted).
 * - `disabled` → `aria-disabled` (control is not actionable).
 * - `idle` / `hover` → no ARIA state.
 */
export function controlStateToAria(state: ControlState): ControlAriaAttrs {
  switch (state) {
    case "inFlight":
      return { "aria-busy": true };
    case "disabled":
      return { "aria-disabled": true };
    default:
      return {};
  }
}
